/**
 * RTWO Native Currency Engine — Null Event Bus Adapter
 */

import type { CurrencyId, RTWONativeCurrencyEventType } from '../domain-models';
import type { EventBusAdapterStatus, IEventBusAdapter } from './event-bus-adapter-interface';

export class NullEventBusAdapter implements IEventBusAdapter {
  readonly adapterId = 'null-event-bus-adapter';
  readonly adapterName = 'Null Event Bus Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): EventBusAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async publishNativeCurrencyEvent(
    _currencyId: CurrencyId,
    _eventType: RTWONativeCurrencyEventType,
    _payloadReference: string,
    _sourceModule: string
  ) {
    return null;
  }
}
